import script from "./bannerCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./bannerCard.vue?vue&type=script&setup=true&lang=ts"

import "./bannerCard.vue?vue&type=style&index=0&id=55006daf&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55006daf"]])

export default __exports__